export default __webpack_public_path__ + "static/media/ic-drag-handle.c7574522.svg";